import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=aa83940a"
import script from "./AppSideBar.vue?vue&type=script&lang=ts"
export * from "./AppSideBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports